import { useEffect } from 'react'
import { AlertBox } from '../../components/ui/layout'
import { useAlertBox, useTabBarContext } from '../../contexts'
import { Wrapper } from './styles'

const Feed = () => {
  const { alertBox } = useAlertBox()
  const { handleChangeTab } = useTabBarContext()

  useEffect(() => {
    if (!window.navigator.onLine) {
      alertBox('Verifique sua conexão com a internet.', [
        {
          title: 'OK',
          action: handleChangeTab('initial')
        }
      ])
    }
  }, [])

  return (
    <>
      <Wrapper>
        <iframe
          src={`${process.env.REACT_APP_DASHBOARD_URL}/player`}
          frameBorder="0"
        />
      </Wrapper>
      <AlertBox />
    </>
  )
}

export default Feed
